import React from "react";

const BottomSection = (props: Record<string, any>): React.JSX.Element => {
  // shows starting time
  //  OR if game is live shows time elapsed
  const { eventTime } = props;
  return <div className="asian-event__time-section--bottom">{eventTime}</div>;
};

export default BottomSection;
